import Vue from 'vue';
import Vuex from 'vuex';
import { getToken, getUserInfoStorage, getProjectData } from '../utils/index';
import apis from '../request/apis.js';

Vue.use(Vuex);
let store = new Vuex.Store({
  state: {
    stateObject: {
      themeCss: {
        color: '#FF8F00'
      },
      pageMap: {},
      userInfo: {},
      merchantDetail: null,
      merchantTypePark: null,
      merchantDetailParkList: null, //传递结算单操作的车位
      merchantGetNewPark: null, //标记是否需要获取新车位
      merchantTypeFee: null, //选择的费用信息,
      token: '',
      userInfo: {},
      systemInfo: {}
    },
    token: getToken(),
    userInfo: getUserInfoStorage(),
    systemInfo: {},
    project: getProjectData(),
    projectInfo: {},
    dictList: []
  },
  mutations: {
    stateFn(state, source) {
      let stateObject = state.stateObject;
      for (let i in source) {
        let key = stateObject[i];
        if (key) {
          let newObj = deepClone({}, state.stateObject[i], source[i]); //这样深拷贝没有getter,setter属性
          let o = {};
          o[i] = newObj;
          Object.assign(state.stateObject, o); //这样就有了getter,setter属性
        }
      }
    },
    stateFn2(state, source) {
      Object.assign(state.stateObject, source);
    },
    //存入token
    setToken(state, source) {
      state.token = source;
      localStorage.setItem('BIGGIF-TOKEN', source);
    },
    //存入用户信息
    setUserInfo(state, source) {
      state.userInfo = source;
      localStorage.setItem('BIGGIF-USERINFO', JSON.stringify(source));
    },
    //存入系统信息
    setSystemInfo(state, source) {
      state.systemInfo = source;
      localStorage.setItem('BIGGIF-SYSTEM', JSON.stringify(source));
    },
    //存入项目id
    setProject(state, source) {
      state.project = source;
      localStorage.setItem('BIGGIF-PROJECT', JSON.stringify(source));
    },
    //存入项目信息
    setProjectInfo(state, source) {
      state.projectInfo = source;
      localStorage.setItem('BIGGIF-PROJECT-INFO', JSON.stringify(source));
    },
    //清除用户信息
    removeUserInfo(state) {
      state.userInfo = {};
      localStorage.setItem('BIGGIF-USERINFO', JSON.stringify({}));
    },
    //清除token
    removeToken(state) {
      state.token = '';
      localStorage.setItem('BIGGIF-TOKEN', '');
    },
    /* 设置字典列表 */
    setDictList(state, source) {
      state.dictList = source;
      // localStorage.setItem('BIGGIF-DICT-LIST', JSON.stringify(source));
    }
  },
  actions: {
    /* 获取字典信息 */
    async getDictList(context) {
      const res = await apis.getDictApi('sale_type');
      if (res.code === '000000') {
        context.commit('setDictList', res.data);
      }
    },
    /* 获取项目信息 */
    async getProjectInfo(context, params) {
      const res = await apis.getProjectInfoApi(params.hisId);
      if (res.code === '000000') {
        context.commit('setProjectInfo', {
          companyId: res.data.companyId,
          hisId: res.data.hisId,
          phone: res.data.phone,
          projectName: res.data.projectName,
          signType: res.data.signType,
          saleType: res.data.saleType
        });
      }
    },
    /* 获取用户信息 */
    async getUserInfo(context) {
      if (!context.state.token) return;
      const { code, data } = await apis.getUserInfoApi();
      if (code == '000000') {
        context.commit('setUserInfo', data);
      }
    }
  }
});

function _type(obj, name) {
  return Object.prototype.toString.call(obj) === '[object ' + name + ']';
}

function isPlainObject(obj) {
  return !!obj && _type(obj, 'Object') && _type(obj.isPrototypeOf, 'Function');
}

function deepClone() {
  var target = arguments[0] || {},
    i = 1,
    length = arguments.length,
    deep = false,
    options,
    name,
    src,
    copy;
  if (typeof target === 'boolean') {
    deep = target;
    target = arguments[1] || {};
    i = 2;
  }
  if (typeof target !== 'object' && !_type(target, 'Function')) {
    target = {};
  }
  if (length === i) {
    target = this;
    --i;
  }
  for (; i < length; i++) {
    if ((options = arguments[i]) != null) {
      for (name in options) {
        src = target[name];
        copy = options[name];
        if (target === copy) {
          continue;
        }
        if (deep && copy && (isPlainObject(copy) || _type(copy, 'Array'))) {
          var clone = src && (isPlainObject(src) || _type(src, 'Array')) ? src : _type(copy, 'Array') ? [] : {};
          target[name] = deepClone(deep, clone, copy);
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }
  return target;
}

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store.js